if (!customElements.get('color-up-ingredient-deck')) {
  customElements.define('color-up-ingredient-deck', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.dialog = this.querySelector('dialog');
      this.frame = this.querySelector('[data-coa-pdf]');
      this.pages = this.querySelector('[data-coa-pages]');
      this.status = this.querySelector('[data-coa-status]');
      this.titleElement = this.querySelector('[data-coa-title]');
      this.openLink = this.querySelector('[data-coa-open]');
      this.clickHandler = (event) => {
        const link = event.target.closest('[data-ingredient-coa]');
        if (link && this.contains(link)) {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0 || typeof this.dialog.showModal !== 'function') return;
          const url = new URL(link.href, location.href);
          if (url.protocol !== 'https:' || !['cdn.shopify.com', location.hostname].includes(url.hostname)) return;
          event.preventDefault();
          this.returnFocus = link;
          this.titleElement.textContent = link.dataset.ingredientName;
          this.openLink.href = url.href;
          this.previousOverflow = document.documentElement.style.overflow;
          this.dialog.showModal();
          document.documentElement.style.overflow = 'hidden';
          this.renderPDF(url.href);
        } else if (event.target.closest('[data-coa-close]')) {
          this.dialog.close();
        } else if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      };
      this.closeHandler = () => {
        this.pdfVersion = (this.pdfVersion || 0) + 1;
        this.renderTask?.cancel();
        this.loadingTask?.destroy().catch(() => {});
        this.pages.replaceChildren();
        this.status.textContent = '';
        this.openLink.removeAttribute('href');
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.returnFocus?.focus({ preventScroll: true });
      };
      this.navHandler = (event) => {
        const link = event.target.closest('a[href^="#cu-ingredients-"]');
        if (!link || !this.closest('article') || link.getAttribute('href') !== '#' + this.closest('article').id) return;
        this.querySelector('details').open = true;
      };
      document.addEventListener('click', this.navHandler);
      this.addEventListener('click', this.clickHandler);
      this.dialog.addEventListener('close', this.closeHandler);
    }
    async renderPDF(url) {
      const version = this.pdfVersion = (this.pdfVersion || 0) + 1;
      this.pages.replaceChildren();
      this.frame.scrollTop = 0;
      this.status.textContent = this.status.dataset.loading;
      try {
        if (!this.pdfLibrary) this.pdfLibrary = import(this.dataset.pdfModule);
        const pdfjs = await this.pdfLibrary;
        if (version !== this.pdfVersion || !this.dialog.open) return;
        pdfjs.GlobalWorkerOptions.workerSrc = this.dataset.pdfWorker;
        this.loadingTask = pdfjs.getDocument({ url, isEvalSupported: false, enableXfa: false, useSystemFonts: true });
        const pdf = await this.loadingTask.promise;
        for (let number = 1; number <= pdf.numPages; number++) {
          if (version !== this.pdfVersion || !this.dialog.open) return;
          const page = await pdf.getPage(number);
          if (version !== this.pdfVersion || !this.dialog.open) return;
          const base = page.getViewport({ scale: 1 });
          const width = Math.max(700, Math.min(1100, this.frame.clientWidth - 32));
          const viewport = page.getViewport({ scale: width / base.width });
          const canvas = document.createElement('canvas');
          canvas.width = Math.ceil(viewport.width * 1.5);
          canvas.height = Math.ceil(viewport.height * 1.5);
          canvas.setAttribute('role', 'img');
          canvas.setAttribute('aria-label', this.titleElement.textContent + ' — ' + number + ' / ' + pdf.numPages);
          this.renderTask = page.render({ canvasContext: canvas.getContext('2d'), viewport, transform: [1.5, 0, 0, 1.5, 0, 0] });
          await this.renderTask.promise;
          if (version !== this.pdfVersion || !this.dialog.open) return;
          const text = await page.getTextContent();
          if (version !== this.pdfVersion || !this.dialog.open) return;
          const accessibleText = document.createElement('div');
          accessibleText.className = 'visually-hidden';
          accessibleText.textContent = text.items.map(item => item.str || '').join(' ');
          this.pages.append(canvas, accessibleText);
          this.status.textContent = '';
        }
      } catch (error) {
        if (version === this.pdfVersion && this.dialog.open) this.status.textContent = this.status.dataset.error;
      }
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        this.closeHandler();
      }
      document.removeEventListener('click', this.navHandler);
      this.removeEventListener('click', this.clickHandler);
      this.dialog?.removeEventListener('close', this.closeHandler);
      this.bound = false;
    }
  });
}
